module.exports = __webpack_public_path__ + "static/primerafecha-96b16f9ce2c5483d12b694d6eadc327f.jpg";